import React from 'react'
import {
  bool, string, func, shape, arrayOf,
} from 'prop-types'
import filter from 'lodash/filter'
import find from 'lodash/find'
import pick from 'lodash/pick'
import omit from 'lodash/omit'
import noop from 'lodash/noop'
import { FacebookButton } from '../../../common/Facebook'
import AppleButton from '../../../common/AppleButton'
import SSOContent from '../../../common/SSOContent'
import TextHr from '../../../common/TextHr'

function SigninWithContent(props) {
  const {
    FacebookBtn, authWithKeycloak,
    clientConfig: {
      signinOptions: signinOptionsForWidget,
    },
    signinOptions: signinOptionsForPage,
    renderModel,
    handleFacebookCreateAccount,
    handleFacebookBindAccount,
    handleShowCoppaEmail,
  } = props

  const isPageModel = renderModel === 'PAGE_RENDER'
  const signinOptions = (!isPageModel ? signinOptionsForWidget : signinOptionsForPage) || []
  if (authWithKeycloak) {
    // Keycloak v5 identity providers
    const facebookData = find(signinOptions, { viewGroup: 'FACEBOOK' })
    const appData = find(signinOptions, { viewGroup: 'APPLE' })
    const ssoDataArr = filter(signinOptions, { viewGroup: 'SSO' })
    const activeData = find(signinOptions, { viewGroup: 'ACTIVE' })
    return (
      <>
        {ssoDataArr.map(ssoData => (
          <SSOContent
            {...ssoData}
            isPageModel={isPageModel}
            {...pick(props, ['renderModel', 'keycloakAPIServerHost', 'onIdpSignin'])}
          />
        ))}
        { ((!!activeData || ssoDataArr.length > 0) && (!!facebookData || !!appData)) && <TextHr id="passport.common.text.or" className="text-uppercase" />}
        { !!facebookData && (
        <FacebookButton
          {...facebookData}
          isPageModel={isPageModel}
          {...pick(props, ['keycloakAPIServerHost', 'onIdpSignin'])}
        />
        )}
        { !!appData && (
        <AppleButton
          {...appData}
          isPageModel={isPageModel}
          {...pick(props, ['keycloakAPIServerHost', 'onIdpSignin'])}
        />
        )}
      </>
    )
  }
  // Passport v4 facebook
  return (
    <FacebookBtn
      handleCreateAccount={handleFacebookCreateAccount}
      handleBindAccount={handleFacebookBindAccount}
      handleShowCoppaEmail={handleShowCoppaEmail}
      facebookText="passport.common.text.signInWith"
      {...omit(props, ['goBack', 'FacebookBtn', 'signinOptions'])}
    />
  )
}

SigninWithContent.propTypes = {
  FacebookBtn: shape({}),
  clientConfig: shape({
    signinOptions: arrayOf(shape({})), // for widget
  }),
  signinOptions: arrayOf(shape({})), // for page
  renderModel: string,
  handleFacebookCreateAccount: func,
  handleFacebookBindAccount: func,
  handleShowCoppaEmail: func,
  authWithKeycloak: bool,
  passportAPIServerHost: string.isRequired,
}

SigninWithContent.defaultProps = {
  clientConfig: {},
  handleFacebookCreateAccount: noop,
  handleFacebookBindAccount: noop,
  handleShowCoppaEmail: noop,
  authWithKeycloak: false,
  FacebookBtn: undefined,
  signinOptions: undefined,
  renderModel: undefined,
}

export default SigninWithContent
